import { createContext, useContext } from 'react';
import { useConfig } from './config-context';
export const FieldInitialDataContext = createContext(undefined);
export const useFieldInitialData = (fieldType)=>{
    const context = useContext(FieldInitialDataContext);
    const { isEditor, isComposer } = useConfig();
    if (isEditor || isComposer) {
        return {};
    }
    if (context === undefined) {
        throw new Error('useFieldInitialData must be used within a FieldInitialDataContext');
    }
    return context[fieldType];
};

//# sourceMappingURL=field-initial-data-context.js.map